import { useNavigate } from "react-router-dom";
import { useTranslation } from "@/lib/i18n";
import { LanguageSelector } from "@/components/shared/LanguageSelector";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Logo } from "@/components/shared/Logo";
import { ArrowLeft, FileText } from "lucide-react";

const SECTIONS = ["s1", "s2", "s3", "s4", "s5", "s6", "s7"];

export default function TermsOfServicePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-slate-50" data-testid="terms-of-service-page">
      <header className="bg-navy-900 border-b border-navy-800">
        <div className="max-w-4xl mx-auto px-4 md:px-8 flex items-center justify-between h-16">
          <div onClick={() => navigate("/")}><Logo size="md" className="text-white cursor-pointer" /></div>
          <LanguageSelector variant="dark" />
        </div>
      </header>
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-8">
        <Button variant="ghost" className="mb-4 text-slate-600 font-body" onClick={() => navigate(-1)} data-testid="terms-back-btn">
          <ArrowLeft className="w-4 h-4 mr-2" /> {t("privacy.back")}
        </Button>
        <Card className="bg-white border-slate-200 shadow-sm">
          <CardHeader className="pb-4">
            <div className="flex items-center gap-3 mb-2">
              <FileText className="w-8 h-8 text-gold-500" />
              <div>
                <CardTitle className="font-sans text-2xl text-slate-900">{t("tos.title")}</CardTitle>
                <p className="text-sm text-slate-500 font-body">{t("tos.subtitle")}</p>
              </div>
            </div>
          </CardHeader>
          <CardContent className="space-y-6 font-body text-slate-700 text-sm leading-relaxed">
            <p>{t("tos.intro")}</p>
            {SECTIONS.map(s => (
              <div key={s}>
                <h3 className="font-sans font-semibold text-base text-slate-900 mb-2">{t(`tos.${s}t`)}</h3>
                <p>{t(`tos.${s}`)}</p>
              </div>
            ))}
            <div className="pt-4 border-t border-slate-200">
              <p className="text-xs text-slate-400">Staffera - admin@staffera.eu</p>
              <p className="text-xs text-slate-400">{new Date().toISOString().split("T")[0]}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
